import { FC } from 'react'
import { InactivityStatus } from './useInactivityTimer'

type SessionCountdownBadgeProps = {
  remainingSeconds: number
  status: InactivityStatus
}

const CRITICAL_THRESHOLD_SECONDS = 15

const formatMMSS = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60
  return `${minutes}:${seconds.toString().padStart(2, '0')}`
}

const formatDescription = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60)
  const seconds = totalSeconds % 60

  const minutesText = minutes > 0 ? `${minutes} ${minutes === 1 ? 'minuto' : 'minutos'}` : ''
  const secondsText = `${seconds} ${seconds === 1 ? 'segundo' : 'segundos'}`

  return minutesText ? `${minutesText} e ${secondsText}` : secondsText
}

export const SessionCountdownBadge: FC<SessionCountdownBadgeProps> = ({
  remainingSeconds,
  status,
}) => {
  const isCritical = status === 'aviso' && remainingSeconds <= CRITICAL_THRESHOLD_SECONDS
  const isWarning = status === 'aviso'

  const dotColorClass = isCritical
    ? 'bg-danger animation-blink'
    : isWarning
    ? 'bg-warning'
    : 'bg-success'

  const textColorClass = isCritical
    ? 'text-danger'
    : isWarning
    ? 'text-warning'
    : 'text-white text-opacity-50'

  const description = `Sessão expira em ${formatDescription(remainingSeconds)}`

  return (
    <span
      role='status'
      aria-live='polite'
      aria-label={description}
      title={description}
      className='d-inline-flex align-items-center'
    >
      <span
        className={`rounded-circle me-2 ${dotColorClass}`}
        style={{ width: 8, height: 8, transition: 'background-color 0.3s ease' }}
        aria-hidden='true'
      />
      <span
        className={`fs-9 fw-semibold ${textColorClass}`}
        style={{ transition: 'color 0.3s ease' }}
      >
        {formatMMSS(remainingSeconds)}
      </span>
    </span>
  )
}
